<template>
  <div class="recruitment-details">
    <v-row>
      <v-col cols="12" lg="4">
        <BaseInformationsCard
          v-model="recruitmentCombined"
          ref="baseInformationsCard"
        />
      </v-col>

      <v-col cols="12" lg="8">
        <FeaturesCard
          ref="recruitmentFeaturesCard"
          :featureGroups="featureGroups"
          class="mb-0"
          @edit="openFeatureEditModal"
        />
      </v-col>
    </v-row>

    <v-row class="mb-4">
      <v-col class="text-right">
        <v-btn
          class="recruitment-details__submit"
          color="blue"
          x-large
          :disabled="!isRecruitmentChanged"
          :loading="isSubmitProcessing"
          :min-width="255"
          @click="submitForm">
          {{ submitName }}
        </v-btn>
      </v-col>
    </v-row>

    <FeaturesModal
      v-model="isFeatureEditModalVisible"
      :selected-feature="selectedFeatureType"
      :features-data="featuresData"
      :processing="isSubmitProcessing"
      submit-name="Add"
      @submit="addFeatures"
    />

    <LanguagesModal
      v-model="isLanguagesModalVisible"
      :languages-data="recruitmentCombined.languages"
      :features-data="featuresData"
      submit-name="Add language"
      @submit="addLanguage"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import BaseInformationsCard from '@/components/Recruitments/BaseInformationsCard.vue';
import FeaturesCard from '@/components/Developers/Show/FeaturesCard.vue';
import FeaturesModal from '@/components/Developers/Show/FeaturesModal.vue';
import LanguagesModal from '@/components/Developers/Show/LanguagesModal.vue';

export default {
  components: {
    BaseInformationsCard,
    FeaturesCard,
    FeaturesModal,
    LanguagesModal,
  },

  props: {
    recruitmentBase: {
      type: Object,
      required: false,
      default: () => ({
        position: '',
        experience_in_years: '',
        start_date: '',
        end_date: '',
        rate: '',
        currency: 'PLN',
        technologies: [],
        management: [],
        project_areas: [],
        languages: [],
      }),
    },

    submitName: {
      type: String,
      required: false,
      default: 'Save',
    },
  },

  data() {
    return {
      isFeatureEditModalVisible: false,
      isLanguagesModalVisible: false,
      selectedFeatureType: {},

      recruitmentUpdated: {},
    };
  },

  computed: {
    ...mapState('recruitment', [
      'isSubmitProcessing',
    ]),

    ...mapState('features', [
      'featuresData',
    ]),

    recruitmentCombined: {
      get() {
        return { ...this.recruitmentBase, ...this.recruitmentUpdated };
      },
      set(value) {
        this.recruitmentUpdated = { ...this.recruitmentUpdated, ...value };
      },
    },

    featureGroups() {
      return [
        {
          name: 'Technologies',
          slug: 'technologies',
          data: this.recruitmentCombined.technologies,
          primary: true,
          required: true,
          emptyTitle: 'Add technology to your application',
          emptyDescription: `Add as many of your skils as
            possible so more recruiters cand find your`,
        },
        {
          name: 'Languages',
          slug: 'languages',
          data: this.recruitmentCombined.languages,
          required: true,
          emptyTitle: 'Would you like to have more precise offers',
          emptyDescription: `Add as many of your skils as
            possible so more recruiters cand find your`,
        },
        {
          name: 'Project areas',
          slug: 'project_areas',
          data: this.recruitmentCombined.project_areas,
          required: true,
          emptyTitle: 'Would you like to have more precise offers',
          emptyDescription: `Add as many of your skils as
            possible so more recruiters cand find your`,
        },
      ];
    },

    isRecruitmentChanged() {
      return Object.keys(this.recruitmentUpdated).length > 0;
    },
  },

  methods: {
    openFeatureEditModal(featureType) {
      if (featureType.slug === 'languages') {
        this.isLanguagesModalVisible = true;
      } else {
        this.selectedFeatureType = featureType;
        this.isFeatureEditModalVisible = true;
      }
    },

    addFeatures(newFeaturesData) {
      const updatedRecruitment = {
        ...this.recruitmentCombined,
        [this.selectedFeatureType.slug]: newFeaturesData,
      };
      this.recruitmentCombined = updatedRecruitment;
      this.isFeatureEditModalVisible = false;
    },

    addLanguage(languageData) {
      const updatedRecruitment = {
        ...this.recruitmentCombined,
        languages: languageData,
      };
      this.recruitmentCombined = updatedRecruitment;
      this.isLanguagesModalVisible = false;
    },

    submitForm() {
      const featuresValid = this.$refs.recruitmentFeaturesCard.validateGroups();
      const baseInformationsValid = this.$refs.baseInformationsCard.validateBaseInformations();

      if (baseInformationsValid && featuresValid) {
        this.$emit('submit', this.recruitmentCombined);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.recruitment-details__submit {
  color: white;
}
</style>
